import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import { useInView } from 'react-intersection-observer';
import WhiteMarker from './WhiteMarker';
import ListingMarker from './Map/ListingMarker';
import cityCoords from '../constants/city_coordinates.json';

export default function GuideMap({ center, listings }) {
  const [activeMarker, setActiveMarker] = useState(null);
  const [bounds, setBounds] = useState(null);

  const [mapLoaded, setMapLoaded] = useState(false);
  useEffect(() => {
    if (window.google) {
      setBounds(new window.google.maps.LatLngBounds());
    }
  }, [mapLoaded]);

  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  const hasCenterCoords = center.lat && center.lng;
  const showListings = !hasCenterCoords || listings.length > 0;

  return (
    <div ref={ref} style={{ width: '100%', height: '100%' }}>
      {inView && (
        <GoogleMapReact
          bootstrapURLKeys={{
            // TODO: REPLACE WITH ENV VAR
            key: 'AIzaSyATvnQePj9OTTCZJ6VkugYM8dRGFPJ5HmQ',
          }}
          defaultCenter={hasCenterCoords ? center : cityCoords.destin}
          defaultZoom={15}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map }) => {
            setMapLoaded(true);
            if (showListings) return map.fitBounds(bounds);
            return null;
          }}
        >
          {showListings && mapLoaded && bounds ? (
            listings.map(listing => {
              const loc = new window.google.maps.LatLng(
                listing.latitude,
                listing.longitude
              );
              bounds.extend(loc);

              return (
                <ListingMarker
                  key={listing.id}
                  lat={listing.latitude}
                  lng={listing.longitude}
                  listing={listing}
                  white_marker
                  type={listing.is_type}
                  changeActiveMarker={setActiveMarker}
                  activeMarker={activeMarker}
                />
              );
            })
          ) : (
            <WhiteMarker lat={center.lat} lng={center.lng} />
          )}
        </GoogleMapReact>
      )}
    </div>
  );
}

GuideMap.propTypes = {
  center: PropTypes.shape({
    lat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    lng: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  listings: PropTypes.array,
};
